import EmbedVideoPlayer from "./EmbedVideoPlayer.vue";

export default EmbedVideoPlayer;
